import React from 'react';

const Lessons = () => {
  return (
    <div className="pt-16 px-4 min-h-screen bg-background text-light">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold text-primary mb-8">Dance Lessons</h1>
        
        {/* June Schedule Notice */}
        <div className="bg-green-600 text-white p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-bold mb-2">🌟 NEW JUNE SCHEDULE!</h2>
          <p className="text-lg mb-2">We've updated our class times and added FREE Friday community events!</p>
          <ul className="text-sm space-y-1">
            <li>• Sunday classes now start at 7PM (Broadway location)</li>
            <li>• Monday classes continue at 6th Ave with same times</li>
            <li>• Friday classes are now FREE community events at Sun Hop Park</li>
          </ul>
        </div>
        
        {/* Free Trial Classes */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-primary mb-6">Try Your First Class Free!</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-light-gray p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-primary mb-2">Sunday Beginners/Improvers</h3>
              <p className="text-secondary mb-4">345 W BROADWAY, VANCOUVER</p>
              <p className="text-secondary mb-4">Choose from:</p>
              <ul className="list-disc list-inside mb-4 text-secondary">
                <li>Bachata: 7-8PM</li>
                <li>Salsa: 8-9PM</li>
              </ul>
              <a 
                href="https://upcoming.azurewebsites.net/sunday"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-light px-6 py-2 rounded-full hover:bg-opacity-90 transition-colors"
              >
                Register for Sunday
              </a>
            </div>

            <div className="bg-light-gray p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-primary mb-2">Friday FREE Community Event</h3>
              <p className="text-secondary mb-4">SUN HOP PARK, 3333 MAIN ST, VANCOUVER</p>
              <div className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold mb-4 inline-block">
                🎉 COMPLETELY FREE!
              </div>
              <ul className="list-disc list-inside mb-4 text-secondary">
                <li>Intro Lesson: 7:00-7:30PM</li>
                <li>Social Dancing: 7:30-9:00PM</li>
              </ul>
              <p className="text-sm text-green-600 font-semibold">
                No registration required - just show up!
              </p>
            </div>
          </div>
        </section>

        {/* Monday Intermediate & Advanced Classes */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-primary mb-6">Intermediate & Advanced Classes</h2>
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="text-xl font-bold text-primary mb-2">Monday Classes</h3>
                <p className="text-secondary mb-4">76 W 6TH AVE, VANCOUVER</p>
                <ul className="list-disc list-inside mb-4 text-secondary">
                  <li>Intermediate Salsa: 6:15-7:15PM</li>
                  <li>Intermediate Bachata: 7:15-8:15PM</li>
                  <li>Advanced Salsa: 8:15-9:15PM <span className="bg-primary text-light text-xs px-2 py-1 rounded-full ml-2">NEW!</span></li>
                </ul>
                <p className="text-secondary mb-4">For dancers with previous experience</p>
              </div>
              <div className="mt-4 md:mt-0">
                <a 
                  href="mailto:info@ruedadance.org?subject=Register%20for%20Monday%20Classes"
                  className="inline-block bg-primary text-light px-6 py-2 rounded-full hover:bg-opacity-90 transition-colors"
                >
                  Email to Register
                </a>
              </div>
            </div>
            <div className="border-t border-secondary border-opacity-20 mt-4 pt-4">
              <p className="text-secondary text-sm">
                Contact us at <a href="mailto:info@ruedadance.org" className="text-primary hover:underline">info@ruedadance.org</a> to register for intermediate and advanced classes or for more information.
              </p>
            </div>
          </div>
        </section>

        {/* Pricing Plans */}
        <section>
          <h2 className="text-2xl font-bold text-primary mb-6">Class Packages</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Single Style Package */}
            <div className="bg-light-gray p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-primary mb-2">Bachata or Salsa</h3>
              <div className="text-secondary mb-4">
                <p className="font-bold">3 one-hour classes</p>
                <p className="text-3xl font-bold text-primary mt-2">$30</p>
              </div>
              <p className="text-sm text-secondary">Perfect for focusing on your preferred style</p>
            </div>

            {/* Combo Package */}
            <div className="bg-light-gray p-6 rounded-lg shadow-lg border-2 border-primary relative">
              <div className="absolute -top-3 right-4 bg-primary text-light text-xs px-2 py-1 rounded-full">
                Best Value
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">Bachata and Salsa</h3>
              <div className="text-secondary mb-4">
                <p className="font-bold">6 one-hour classes</p>
                <p className="text-3xl font-bold text-primary mt-2">$50</p>
              </div>
              <p className="text-sm text-secondary">Experience both styles at a great price</p>
            </div>

            {/* Drop In */}
            <div className="bg-light-gray p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-primary mb-2">Drop In</h3>
              <div className="text-secondary mb-4">
                <p className="font-bold">per one-hour class</p>
                <p className="text-3xl font-bold text-primary mt-2">$15</p>
              </div>
              <p className="text-sm text-secondary">Flexible option for busy schedules</p>
            </div>
          </div>
        </section>

        {/* Payment Options */}
        <section className="mt-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">Payment Options</h3>
            <div className="space-y-4">
              <p className="text-secondary">Choose your preferred payment method:</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-background rounded-lg">
                  <p className="text-light font-bold mb-2">Pay with Cash</p>
                  <p className="text-secondary text-sm">Available at the studio before class</p>
                </div>
                <div className="p-4 bg-background rounded-lg">
                  <p className="text-light font-bold mb-2">Pay with Card</p>
                  <p className="text-secondary text-sm mb-3">Secure online payment</p>
                  <a 
                    href="https://checkout.square.site/merchant/MLBQYHXVHCTX2/checkout/6B4DZTJBOHPE65EQS6STKRWC"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-primary text-light px-6 py-2 rounded-full hover:bg-opacity-90 transition-colors"
                  >
                    Pay Online
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Information */}
        <section className="mt-8">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">June 2025 Schedule Updates</h3>
            <div className="grid md:grid-cols-3 gap-6 mb-6">
              <div>
                <h4 className="font-bold text-secondary mb-2">🔵 SUNDAY Classes</h4>
                <p className="text-sm text-secondary mb-2">345 W Broadway</p>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• 7-8PM: Beginner Bachata</li>
                  <li>• 8-9PM: Beginner Salsa</li>
                  <li>• 9-10PM: Social Dancing</li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-secondary mb-2">🟢 MONDAY Classes</h4>
                <p className="text-sm text-secondary mb-2">76 W 6th Ave</p>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• 6:15-7:15PM: Intermediate Salsa</li>
                  <li>• 7:15-8:15PM: Intermediate Bachata</li>
                  <li>• 8:15-9:15PM: Advanced Salsa</li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-secondary mb-2">🟠 FRIDAY Events</h4>
                <p className="text-sm text-secondary mb-2">Sun Hop Park, 3333 Main St</p>
                <div className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold mb-2 inline-block">
                  FREE COMMUNITY EVENT
                </div>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• 7:00-7:30PM: Intro Lesson</li>
                  <li>• 7:30-9:00PM: Social Dancing</li>
                </ul>
              </div>
            </div>
            <div className="border-t border-secondary border-opacity-20 pt-4">
              <h4 className="font-bold text-secondary mb-2">Class Information</h4>
              <ul className="space-y-2 text-secondary">
                <li>• All levels welcome (except Monday intermediate/advanced)</li>
                <li>• No partner required</li>
                <li>• First Sunday class free trial available</li>
                <li>• Friday events are completely FREE - no registration needed!</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Lessons;